<template>
  <cms-shell :data="data" title="Key Visual" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
    <span>Claim 1</span>
    <textarea type="text" class="form-control" v-model="data.claim1" placeholder="Claim 1"/>

    <div style="margin-top: 0.5rem;">Claim 2</div>
    <textarea type="text" class="form-control" v-model="data.claim2" placeholder="Claim 2"/>

    <div style="margin-top: 0.5rem;">Claim 3</div>
    <textarea type="text" class="form-control" v-model="data.claim3" placeholder="Claim 3"/>

    <div style="margin-top: 0.5rem;">Event Over Claim</div>
    <textarea type="text" class="form-control" v-model="data.claimOver" placeholder="Claim Event Over"/>

    <div style="margin-top: 1.5rem;">Subline</div>
    <textarea type="text" class="form-control" v-model="data.value" placeholder="Subline"/>
  </cms-shell>

</template>

<script>
  import CmsShell from "./CmsShell";

  export default {
    components: {CmsShell},
    name: "cms-keyvisual",
    props: ['data']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsKeyVisual.vue